export const SUPPLIER_NAME_ASWO = "ASWO";
export const SUPPLIER_NAME_SDS = "SDS";
